import React, { useEffect, useState } from 'react'
import { showLoader } from '../../../../Redux/Slices/loaderSlice'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { api_config, update_config } from '../../../../Redux/Actions/action'
import ErrorHandler from '../../../../Utils/handler'
import CommonTextField from '../../../Common/CommonTextField'
import { Grid, InputLabel, Switch } from '@mui/material'
import ButtonContained from '../../../Common/ButtonContained'
import TextLabel from '../../../Common/CommonTextLabel'

const ConfigSetting = () => {
    const dispatch = useDispatch()
    const [data, setData] = useState({})
    const [errors, setErrors] = useState({});

    const _api_config = async () => {
        dispatch(showLoader(true))
        try {
            const result = await dispatch(api_config());
            const error = ErrorHandler(result);
            if (error) {
                setData(result?.payload?.data?.response)
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    const validation = () => {
        let errors = {};
        let valid = true;
        if (!data.bandharanTitle) {
            errors.bandharanTitle = "Please enter Bandharan Title.";
            valid = false;
        }
        if (!data.bandharanUrl) {
            errors.bandharanUrl = "Please enter Bandharan Url.";
            valid = false;
        }

        setErrors(errors);
        return valid;
    };

    const _update_config = async () => {
        if (validation()) {
            dispatch(showLoader(true))
            const body = {
                _id: data?._id,
                bandharanTitle: data?.bandharanTitle,
                bandharanUrl: data?.bandharanUrl,
                aadhaarEVerification: data?.aadhaarEVerification,
            }
            try {
                const result = await dispatch(update_config(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast.success(result?.payload?.message);
                    _api_config()
                }
            } catch (error) {
                toast.error(error);
            } finally {
                dispatch(showLoader(false))
            }
        }
    }


    useEffect(() => {
        _api_config()
    }, [])
    return (
        <>
            <Grid container spacing={2}>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                    <CommonTextField
                        text={"Bandharan Title"}
                        type={"text"}
                        placeholder={`Enter Bandharan Title`}
                        name={"bandharanTitle"}
                        width="100%"
                        value={data?.bandharanTitle}
                        valid={true}
                        onChange={(e) => setData({ ...data, bandharanTitle: e.target.value })}
                    />
                    <TextLabel title={!data?.bandharanTitle ? errors.bandharanTitle : ""} color="error" />
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                    <CommonTextField
                        text={"Bandharan Url"}
                        type={"text"}
                        placeholder={`Enter Bandharan Url`}
                        name={"bandharanUrl"}
                        width="100%"
                        value={data?.bandharanUrl}
                        valid={true}
                        onChange={(e) => setData({ ...data, bandharanUrl: e.target.value })}
                    />
                    <TextLabel title={!data?.bandharanUrl ? errors.bandharanUrl : ""} color="error" />
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                    <InputLabel
                        sx={{
                            letterSpacing: "0.03em",
                            marginRight: "2px",
                            fontSize: "14px",
                            color: "#222222",
                            whiteSpace: "wrap",
                            marginBottom: "0px"
                        }}
                    >
                        {"Aadhaar E Verification"}
                    </InputLabel>
                    <Switch
                        checked={data?.aadhaarEVerification}
                        color="primary"
                        onChange={(e) => {
                            setData({ ...data, aadhaarEVerification: e.target.checked })
                        }} />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"end"}>
                    <ButtonContained
                        text={"Update"}
                        onClick={() => {
                            _update_config()
                        }}
                    />
                </Grid>
            </Grid>

        </>
    )
}

export default ConfigSetting
